module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/smile-ea6922b4e03f7cd2cb9ad7cf41eb6abb.svg";